import React, { useState } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Grid,
  InputAdornment,
  MenuItem,
  Divider,
  Link,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { Email, Business, Category } from "@mui/icons-material";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "libphonenumber-js";
import { BASEURL, CONTACT_ERORR_MOBILE_NO } from "../../../constant/constant";
import { InstituteCreateSchemaConferance } from "../../../schema/schema";
import { apiCall } from "../../../API/apiCall";
import { toast } from "react-toastify";
import Loader from "../../loader/Loader";
import TermsAndConditions from "./TermsAndConditions";

const InstituteRegistrationForm = () => {
  const [formData, setFormData] = useState({
    instituteName: "",
    instituteType: "",
    email: "",
    phone: "",
    address: "",
    firstName: "",
    lastName: "",
    agreed: false,
  });

  const [formError, setFormError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const instituteTypes = [
    "School",
    "College",
    "University",
    "Training Center",
    "Coaching Institute",
    "Online Academy",
    "Research Institute",
    "Other",
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckboxChange = (event) => {
    setFormData({
      ...formData,
      ["agreed"]: event.target.checked,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const error = InstituteCreateSchemaConferance({
      email: formData?.email,
      InstituteName: formData?.instituteName,
      InstituteType: formData?.instituteType,
      phone: formData?.phone,
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      InstituteAddress: formData?.address,
    });

    if (Object.keys(error).length !== 0) {
      setFormError(error);
      return;
    }

    console.log(formData?.phone);

    if (formData?.phone && !isValidPhoneNumber(`+${formData?.phone}`)) {
      setFormError({});
      setFormError((prev) => ({ ...prev, phone: CONTACT_ERORR_MOBILE_NO }));
      return;
    }

    const config = {
      url: "/institute/conference/register",
      method: "POST",
      data: { ...formData, origin: "qrcode" },
    };

    setIsLoading(true);

    try {
      const response = await apiCall(config);
      if (response.status === "success") {
        toast.success(response.message);
        setFormData({
          instituteName: "",
          instituteType: "",
          email: "",
          phone: "",
          address: "",
          firstName: "",
          lastName: "",
        });
        setFormError({});
      }
    } catch (err) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <>
      {isLoading && <Loader />}
      <Container maxWidth="lg" sx={{ py: 2.5 }}>
        <Grid container spacing={4} justifyContent="center">
          {/* Left Side - Branding */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                textAlign: { xs: "center", md: "left" },
                mb: 4,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: 600,
                  p: 1,
                  mb: 5,
                  ml: -3,
                }}
              >
                <img
                  src={`${BASEURL}/assets/logo.png`}
                  alt="Readmax_logo"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </Box>

              <Typography
                variant="h4"
                component="h2"
                gutterBottom
                sx={{
                  fontWeight: 700,
                  color: "#000",
                  fontSize: "3.7rem",
                  mb: "2rem",
                }}
              >
                Create a new Account
              </Typography>

              <Box>
                <img
                  src="https://readmax.com/static/media/loginImg.c708d47911264cd4e74f.png"
                  alt="girl_image"
                ></img>
              </Box>

              <Typography
                variant="body1"
                sx={{
                  color: "text.secondary",
                  mb: 2,
                  fontSize: { xs: "1rem", md: "1.1rem" },
                }}
              >
                If you already have an account
                <br />
                You Can{" "}
                <Link
                  href="/login"
                  sx={{ fontWeight: "bold", textDecoration: "none" }}
                >
                  Sign In here!
                </Link>
              </Typography>

              <Divider sx={{ my: 3 }} />
            </Box>
          </Grid>

          {/* Right Side - Registration Form */}

          <Grid item xs={12} md={6}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: "primary.main",
                fontSize: { xs: "1.5rem", md: "1.75rem" },
              }}
            >
              Register Here!
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                mt: 1,
                mb: 3,
              }}
            >
              Enter the login information for your account. You will be able to
              visit here after the registering.
            </Typography>
            <Paper
              elevation={3}
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: 2,
              }}
            >
              <form onSubmit={handleSubmit}>
                {/* Personal Information Section */}
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontWeight: 600, mb: 3 }}
                >
                  Personal Information
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="First Name"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      variant="outlined"
                      sx={{ mb: formError.firstName ? 0.5 : 2 }}
                      error={!!formError.firstName}
                    />
                    {formError?.firstName && (
                      <Typography
                        variant="caption"
                        color="error"
                        sx={{ mt: 0 }}
                      >
                        {formError?.firstName}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      variant="outlined"
                      sx={{ mb: formError.lastName ? 0.5 : 2 }}
                      error={!!formError.lastName}
                    />
                    {formError?.lastName && (
                      <Typography variant="caption" color="error">
                        {formError?.lastName}
                      </Typography>
                    )}
                  </Grid>
                </Grid>

                {/* Institute Information Section */}
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontWeight: 600, mt: 3, mb: 3 }}
                >
                  Institute Information
                </Typography>

                <Box sx={{ mb: 2 }}>
                  <TextField
                    fullWidth
                    label="Institute Name"
                    name="instituteName"
                    value={formData.instituteName}
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Business color="action" />
                        </InputAdornment>
                      ),
                    }}
                    error={!!formError.InstituteName}
                  />
                  {formError?.InstituteName && (
                    <Typography variant="caption" color="error">
                      {formError?.InstituteName}
                    </Typography>
                  )}
                </Box>

                <FormControl fullWidth variant="outlined" sx={{ mb: 2 }}>
                  <InputLabel>Institute Type *</InputLabel>
                  <Select
                    name="instituteType"
                    value={formData.instituteType}
                    onChange={handleChange}
                    label="Institute Type"
                    startAdornment={
                      <InputAdornment position="start">
                        <Category color="action" />
                      </InputAdornment>
                    }
                  >
                    {instituteTypes.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                  {formError?.InstituteType && (
                    <Typography variant="caption" color="error">
                      {formError?.InstituteType}
                    </Typography>
                  )}
                </FormControl>

                <Box sx={{ mb: formError.email ? 1.5 : 0 }}>
                  <TextField
                    fullWidth
                    label="Email Address"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email color="action" />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ mb: formError.email ? 0.5 : 2 }}
                    error={!!formError.email}
                  />
                  {formError?.email && (
                    <Typography variant="caption" color="error">
                      {formError?.email}
                    </Typography>
                  )}
                </Box>

                <Box sx={{ mb: 2 }}>
                  <PhoneInput
                    country={"us"}
                    enableSearch={true}
                    name="phone"
                    onChange={(e) =>
                      handleChange({ target: { name: "phone", value: e } })
                    }
                    value={formData?.phone}
                    inputStyle={{
                      height: "56px",
                    }}
                    // required={true}
                    sx={{ mb: formError.phone ? 0.5 : 2 }}
                    error={!!formError.phone}
                  />
                  {formError?.phone && (
                    <Typography variant="caption" color="error">
                      {formError?.phone}
                    </Typography>
                  )}
                </Box>

                <Box sx={{ mb: 1.5 }}>
                  <TextField
                    fullWidth
                    label="Institute Address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    multiline
                    rows={3}
                    variant="outlined"
                    sx={{ mb: formError.InstituteAddress ? 0.5 : 2 }}
                    error={!!formError.InstituteAddress}
                  />
                  {formError?.InstituteAddress && (
                    <Typography variant="caption" color="error">
                      {formError?.InstituteAddress}
                    </Typography>
                  )}
                </Box>

                <TermsAndConditions
                  agreed={formData.agreed}
                  handleCheckboxChange={handleCheckboxChange}
                  handleOpenDialog={handleOpenDialog}
                  handleCloseDialog={handleCloseDialog}
                  openDialog={openDialog}
                />

                {/* Submit Button */}
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  size="large"
                  sx={{
                    py: 1.5,
                    fontSize: "1.1rem",
                    fontWeight: "bold",
                    borderRadius: 2,
                  }}
                  disabled={isLoading || !formData?.agreed}
                >
                  Submit
                </Button>

                {/* Sign In Link */}
                <Box sx={{ textAlign: "center", mt: 2 }}>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    Already have an account?{" "}
                    <Link
                      href="/login"
                      sx={{ fontWeight: "bold", textDecoration: "none" }}
                    >
                      Sign In here!
                    </Link>
                  </Typography>
                </Box>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default InstituteRegistrationForm;
